
import React from "react";
import TerugNaarHomeButton from "../components/ui/TerugNaarHomeButton";

export default function PaginaLoader({ message = "Een ogenblik geduld…" }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] text-center space-y-4">
      {/* Spinner */}
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>

      {/* Tekst */}
      <div>
        <p className="text-lg font-semibold">{message}</p>
        <p className="text-sm text-gray-500">
          We halen de gegevens op uit uw omgeving, dit kan even duren.
        </p>
      </div>

      {/* Hergebruikte knop */}
      <TerugNaarHomeButton />
    </div>
  );
}
